import { useRef, useState } from 'react'
import { MdInfoOutline as InfoIcon } from 'react-icons/md'
import styled from '@emotion/styled'
import { StyledHTMLElement } from 'shop/theme/types'
import TooltipPopup from './TooltipPopup'

const IconTooltip = ({
  tooltipMessage,
  tooltipHeader,
  iconSize = '16px'
}: {
  tooltipMessage: string
  tooltipHeader?: string
  iconSize?: string
}) => {
  const [showToolip, setShowToolip] = useState(false)
  const elRef = useRef(null)

  return (
    <TooltipContainer
      ref={elRef}
      onClick={() => setShowToolip(!showToolip)}
      onMouseEnter={() => setShowToolip(true)}
      onMouseLeave={() => setShowToolip(false)}
    >
      {showToolip && (
        <TooltipPopup
          tooltipMessage={tooltipMessage}
          headerTitle={tooltipHeader}
          targetRef={elRef}
          onClose={() => setShowToolip(false)}
        />
      )}
      <InfoIcon data-testid='info-icon' size={iconSize} />
    </TooltipContainer>
  )
}

const TooltipContainer = styled.div<StyledHTMLElement>(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  alignSelf: 'center',
  position: 'relative',

  '& svg': {
    color: '#595959'
  }
}))

export default IconTooltip
